import script from "./Wall4View.vue?vue&type=script&setup=true&lang=js"
export * from "./Wall4View.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__